<app-loader *ngIf="!dataSource.data[0]?.name" [size]="30"></app-loader>
<app-tree-view
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  [activeNodes]="activeNodes"
></app-tree-view>
